export const MATCH_SECRET_PATH = "/opal-griffin/";
export const LOCAL_MATCH_PATH = "/match/";

export function normalizeRoutePath(pathname: string): string {
  const pathOnly = pathname.split(/[?#]/, 1)[0] ?? "/";
  const withLeadingSlash = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  const withoutTrailingSlashes = withLeadingSlash.replace(/\/+$/, "");
  if (withoutTrailingSlashes === "") return "/";
  return `${withoutTrailingSlashes}/`;
}

export function isMatchPreviewPath(pathname: string): boolean {
  return normalizeRoutePath(pathname) === normalizeRoutePath(MATCH_SECRET_PATH);
}

export function isLocalMatchPath(pathname: string): boolean {
  return normalizeRoutePath(pathname) === normalizeRoutePath(LOCAL_MATCH_PATH);
}
